import React, { useState } from 'react'
import Headerone from '../headerone/newMain'
import Bredcom from '../Bredcom/Main'

function FinanceOfficer() {
    return (
        <>
            <Headerone />
            <Bredcom title="Home" subtitle="Finance Officer" />
            <section className="about-area about-p pt-120 pb-120 p-relative fix">
                <div className="animations-02">
                    <img src="/assets/img/bg/an-img-02.png" alt="contact-bg-an-01" />
                </div>
                <div className="container">
                    <div className="row justify-content-center align-items-center">                        
                        <div className="col-lg-12 col-md-12 col-sm-12">
                            <div className="about-content s-about-content pl-15 wow fadeInRight  animated" data-animation="fadeInRight" data-delay=".4s" >
                                <div className="about-title second-title pb-25">                                    
                                    <h3>Coming Soon..</h3>
                                </div>
                                {/* <p>
                                Department of Physiotherapy was established under School of Allied Health Sciences (SOAHS) in year 2017. Here, at MVN university, Department of Physiotherapy, we are morally bound to enlighten and equip the students with appropriate skills by rendering knowledge in a interesting way. Here, we have a team of highly qualified and experienced faculty ably supported by an equally dedicated staff.
                                </p> */}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default FinanceOfficer